import { type Dict } from "../@types/Dict";

export function isObject(value: unknown): value is Dict {
  const type = typeof value;
  // eslint-disable-next-line eqeqeq
  return value != null && type === "object";
}
